"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransformSchematicModelInstanceConfiguration = void 0;
const TransformObject_1 = require("./TransformObject");
class TransformSchematicModelInstanceConfiguration extends TransformObject_1.TransformObject {
    constructor(parent, baseConfiguration) {
        super(parent, {
            baseConfiguration,
        }, baseConfiguration.instanceId, new Set());
        this.deduplicationKey = baseConfiguration.instanceId;
    }
    compile() {
        return this._sharedData.baseConfiguration;
    }
}
exports.TransformSchematicModelInstanceConfiguration = TransformSchematicModelInstanceConfiguration;
//# sourceMappingURL=TransformSchematicModelInstanceConfiguration.js.map